import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Product } from '@app/akita/api/products/models/product.model';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import {
  BaseetaPromoComponent,
  SHOW_BASEETA_PROMO,
} from '@app/checkout/payment-providers/baseeta/components/baseeta-promo/baseeta-promo.component';
import { TabbyPromoComponent } from '@app/checkout/payment-providers/tabby/components/tabby-promo/tabby-promo.component';
import { TamaraSummaryComponent } from '@app/checkout/payment-providers/tamara/components/tamara-summary/tamara-summary.component';
import { ChevronDownIconComponent } from '@app/shared/components/icons/generated/chevron-down/chevron-down.component';
import { PriceModel } from '@app/shared/models/api/price.model';
import { AmountPipe } from '@app/shared/pipes/amount.pipe';
import { TranslocoModule } from '@ngneat/transloco';
import { Observable } from 'rxjs';
import { BaseetaBadgeComponent } from '../../../checkout/payment-providers/baseeta/components/baseeta-badge/baseeta-badge.component';
import { TabbyBadgeComponent } from '../../../checkout/payment-providers/tabby/components/tabby-badge/tabby-badge.component';
import { TamaraBadgeComponent } from '../../../checkout/payment-providers/tamara/components/tamara-badge/tamara-badge.component';
import { AlrajhiPromoComponent } from '../../../checkout/components/alrajhi-promo/alrajhi-promo.component';
import { AlrajhiLogoIconComponent } from '../../../shared/components/icons/generated/alrajhi-logo/alrajhi-logo.component';
import { CommonModule } from '@angular/common';
import { WataniyaBadgeComponent } from '../../../checkout/payment-providers/wataniya/components/wataniya-badge/wataniya-badge.component';
import {
  SHOW_WATANIYA_PROMO,
  WataniyaPromoComponent,
} from '../../../checkout/payment-providers/wataniya/components/wataniya-promo/wataniya-promo.component';
import {
  SHOW_TAMAM_PROMO,
  TamamPromoComponent,
} from '@app/checkout/payment-providers/tamam/components/tamam-promo/tamam-promo.component';
import { TamamBadgeComponent } from '@app/checkout/payment-providers/tamam/components/tamam-badge/tamam-badge.component';

@Component({
  selector: 'app-product-installment-options',
  templateUrl: './product-installment-options.template.html',
  styleUrls: ['./product-installment-options.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoModule,
    RouterModule,
    CommonModule,
    ChevronDownIconComponent,
    BaseetaPromoComponent,
    TamaraSummaryComponent,
    TabbyPromoComponent,
    AmountPipe,
    BaseetaBadgeComponent,
    TabbyBadgeComponent,
    TamaraBadgeComponent,
    AlrajhiPromoComponent,
    AlrajhiLogoIconComponent,
    WataniyaBadgeComponent,
    WataniyaPromoComponent,
    TamamBadgeComponent,
    TamamPromoComponent,
  ],
})
export class ProductInstallmentOptionsComponent {
  @Input() public product?: Product | null;
  @Input() public price?: PriceModel | null;
  @Input() public tamaraInstallmentPrice?: PriceModel | null;
  @Input() public installmentsCount?: number | null;

  public readonly lessThan$: Observable<ScreenSizeInfoState>;

  public readonly isRtl$: Observable<boolean>;

  public isCollapsed = true;
  public showBaseetaPromo = SHOW_BASEETA_PROMO;
  public showWataniyaPromo = SHOW_WATANIYA_PROMO;
  public showTamamPromo = SHOW_TAMAM_PROMO;

  constructor(
    private readonly akitaRouterQuery: AkitaRouterQuery,
    private readonly akitaScreenQuery: AkitaScreenQuery
  ) {
    this.isRtl$ = this.akitaRouterQuery.selectIsRtlLayout();
    this.lessThan$ = this.akitaScreenQuery.selectLessThan();
  }

  public capitalizeCategory(str: string): string | null {
    return str
      .charAt(0)
      .toUpperCase()
      .concat(str.slice(1).replace(/ /g, '_').toLowerCase());
  }

  public trackByItem(index: number, item?: any): string {
    return item?.id || `${index}`;
  }
}
